import { render, staticRenderFns } from "./Batchorder.vue?vue&type=template&id=3f9e0a2b&scoped=true"
import script from "./Batchorder.vue?vue&type=script&lang=js"
export * from "./Batchorder.vue?vue&type=script&lang=js"
import style0 from "./Batchorder.vue?vue&type=style&index=0&id=3f9e0a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e0a2b",
  null
  
)

export default component.exports